import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IError } from 'src/app/interfaces/error.interface';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-select-holding',
  templateUrl: './select-holding.component.html',
  styleUrls: ['./select-holding.component.css']
})
export class SelectHoldingComponent implements OnInit {

  form: FormGroup;
  holdingList: any;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  serviceUrl = environment.BaaseUrl

  constructor(
    private fb: FormBuilder,
    private holdingService: HoldingService,
    private errorService: ErrorsService,
    private dialogRef: MatDialogRef<SelectHoldingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
    this.getAllHolding();
    console.log(this.data);

  }

  createForm() {
    this.form = this.fb.group({
      holding: [null, Validators.required]
    });
  }

  getAllHolding() {
    this.holdingService.allList().subscribe(res => {
      this.holdingList = res.DataList;
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    });
  }

  submit(data: any) {
    this.dialogRef.close(this.holdingList.filter(function (el) {
      return el.HoldingEncryptCode == data.holding
    })[0]);
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}
